import axios from 'axios';
import ADMIN_PORTAL_LOGO from '@/assets/images/apilogy-logo.png';
import ADMIN_PORTAL_IMAGE from '@/assets/images/admin-portal-image.png';
import CLOUD_IMAGE from '@/assets/images/cloud.png';
import MainHeader from '@/components/MainHeader';
import MainContent from '@/components/MainContent';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccessToken, getRefreshToken } from '@/services/utilities';
import { frontConfig } from '@/config/front-config';
import useLoadingStore from '@/store/loading';
const config = frontConfig();

const MainPage = () => {
  const navigate = useNavigate();   
  const { setLoading } = useLoadingStore();     
  const onLoginHandle = async () => {
    try {
      const {
        data: { data: authUrl },
      } = await axios.get(`${config.adminPortalBaseUrl}/auth/url`);

      window.open(authUrl, '_self');
    } catch (error) {
      console.error('Failed to fetch authentication URL', error);
    }
  };

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const { data } = await axios.get(`${config.adminPortalBaseUrl}/auth/is-login`, {
          withCredentials: true,
        });
        if (!data.data.userLoggedIn) {
          navigate('/');
        } else {
          navigate('/users');
        }
      } catch (error) {
        console.error('Error checking login status', error);
        navigate('/');
      }
    };

    checkLoginStatus();
  }, [navigate]);

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      
      
      {/* Header Bar */}
      <MainHeader logo={ADMIN_PORTAL_LOGO} onLogin={onLoginHandle} />

      {/* Main Content - with top padding to account for fixed header */}
      <div className="grid items-center grid-cols-1 gap-8 pb-16 pt-20 md:grid-cols-2">
        <MainContent onLogin={onLoginHandle} />

        {/* Right Section with Cloud Background */}
        <div
          className="flex items-center justify-center bg-center bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${CLOUD_IMAGE})`,
          }}
        >
          {/* Image in the Right Section */}
          <img
            src={ADMIN_PORTAL_IMAGE}
            alt="img-admin-portal"
            className="object-contain w-full max-h-80vh"
          />
        </div>
      </div>
    </div>
  );
};

export default MainPage;
